<template lang="html">
    <div>
      <v-toolbar
        color="green"
        dark
        tabs
      >
        <v-toolbar-title><h1>{{title}}</h1></v-toolbar-title>

        <v-spacer></v-spacer>
        
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            color="green"
            grow
          >
            <v-tabs-slider color="brown"></v-tabs-slider>

            <v-tab
              v-for="item in items"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in texts"
          :key="item"
        >
          <v-card flat>
            <v-sheet
                      class="pa-5"
                      color="green lighten-5">
                      <v-sheet
                        class="mx-auto"
                        height="500"
                        width="1200"
                        color="green lighten-2">
                      <v-card-text>
                        <h2 class="subheading" v-html="item"></h2>
                      </v-card-text>

                    </v-sheet>
                    </v-sheet>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </template>

  <script>
    export default {
      data () {
        return {
          tab: null,
          title:this.$t('testimonials.TITLE'),
          items: [
            this.$t('testimonials.item1.TITLE'), this.$t('testimonials.item2.TITLE'), this.$t('testimonials.item3.TITLE')
          ],
          texts: [
            this.$t('testimonials.item1.TEXT'), this.$t('testimonials.item2.TEXT'), this.$t('testimonials.item3.TEXT')
          ]
        }
      }
    }
  </script>
